import React from "react"

function Footer() {
    return (
        <footer class="page-footer font-small blue footer">

            <div class="footer-copyright text-center py-3">Made with ❤ by
        <a href="https://about.me/adewaletoluwani" target="_blank" rel="noopener noreferrer" className="author"> Toluwani Adewale</a>
            </div>

        </footer>
    );
}

export default Footer;